module.exports = __webpack_public_path__ + "static/media/multipostingHelper3.a6296013.png";